import { useTranslation } from 'next-i18next';
import { getCdnTranslationProps } from '../../../utils/server/i18n/getCdnTranslationProps';

import { SUPPORTED_LANGUAGES } from '@inflearn/i18n-tools';
import type { Language } from '@inflearn/i18n-tools';
import type { GetServerSidePropsContext } from 'next/types';
import PolicyLayout from '../../../components/layout/PolicyLayout';
import { PolicyContent } from '../../../components/pages/policy/PolicyContent';
import { HAS_GUIDE_LANG } from '../../../utils/i18n/hasGuideLang';

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  const locale = context.locale as Language;
  const isWebview = context.query.type === 'app';

  if (HAS_GUIDE_LANG.includes(locale)) {
    return {
      props: {
        isWebview: isWebview,
        ...(await getCdnTranslationProps(locale, ['common'])),
      },
    };
  }

  return {
    props: {
      isWebview: isWebview,
      ...(await getCdnTranslationProps(SUPPORTED_LANGUAGES.en, ['common'])),
    },
  };
};

export default function PolicyTermsOfServicePage({
  isWebview,
}: {
  isWebview: boolean;
}) {
  const { t } = useTranslation();

  return (
    <PolicyLayout
      meta={{
        title: '메타.인프런이용약관.제목',
        description: '메타.인프런이용약관.설명',
      }}
      isWebview={isWebview}
    >
      <PolicyContent
        title={t('인프런 이용약관')}
        prevPolicy={{
          href: '/policy/previous-terms-of-service',
          buttonText: t('이전 이용약관 보기'),
        }}
        type="TERMS"
        period="CURRENT"
        isWebview={isWebview}
      />
    </PolicyLayout>
  );
}
